document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-banner]').forEach(wrapper => {
    const description = wrapper.querySelector('.collection-banner__description')
    const btn = wrapper.querySelector('[data-read-more]')
    const text = wrapper.querySelector('[data-read-more-text]')
    if (!description || !btn) return

    const checkOverflow = () => {
      description.style.maxHeight = 'none'
      description.classList.remove('is-expanded')
      
      const lineHeight = parseFloat(getComputedStyle(description).lineHeight)
      const maxHeight = lineHeight * 3
      
      if (description.scrollHeight > maxHeight) {
        description.classList.add('has-read-more')
        description.style.maxHeight = `${maxHeight}px`
        btn.style.display = 'block'
      } else {
        description.classList.remove('has-read-more')
        description.style.maxHeight = 'none'
        btn.style.display = 'none'
      }
    }

    const toggle = () => {
      const expanded = description.classList.toggle('is-expanded')
      const lineHeight = parseFloat(getComputedStyle(description).lineHeight)
      description.style.maxHeight = expanded ? `${description.scrollHeight}px` : `${lineHeight * 3}px`
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false')
      if (text) text.textContent = expanded ? 'Read Less' : 'Read More'
    }

    checkOverflow()
    btn.addEventListener('click', toggle)
    window.addEventListener('resize', checkOverflow)
  })
})